import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';


const AdminRoute = () => {
  const auth = useSelector((state) => state.auth.user);
  const token = auth?.data?.authToken

  if (!token) {
    return <Navigate to="/" />;
  }

  return <Outlet />
};

export default AdminRoute